import {Record, Map} from "immutable"

type Practice = "intermural" | "undergraduate"

export const practiceTitleMap = {
    internship: 'Производственная практика',
    undergraduate: 'Преддипломная практика',
    probation: 'Стажировка',
}

interface Properties {
    id: number
    target: boolean
    opk: boolean
    demandYear: number
    citizenship: string
    practiceType: Practice
    details: number
    demand: number
    gpa: number | undefined
}

export class Trainee extends Record({
    id: undefined,
    target: undefined,
    opk: undefined,
    demandYear: undefined,
    citizenship: undefined,
    practiceType: undefined,
    details: undefined,
    demand: undefined,
    gpa: undefined,
}) implements Properties {
    id: number
    target: boolean
    opk: boolean
    demandYear: number
    citizenship: string
    practiceType: Practice
    details: number
    demand: number
    gpa: number | undefined

    constructor(values: Properties) {
        super(values)
    }
}

export type JsonData =  {
    id: number
    target: number
    opk: number
    demandYear: number
    citizenship: string
    practiceType: Practice
    details: number
    demand: number
    gpa: number | undefined
}

export const fromJs = ({
    id,
    target,
    opk,
    demandYear,
    citizenship,
    practiceType,
    details,
    demand,
    gpa,
}: JsonData): Trainee => new Trainee({
    id,
    target: !!target,
    opk: !!opk,
    demandYear,
    citizenship,
    practiceType,
    details,
    demand,
    gpa,
})

export type Trainees = Map<number, Trainee>